import { useMarkFlowCompleted } from "@Light/components/optOutSurvey";
import { Button } from "@Light/components/page/Button";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { useScaffold } from "@Light/scaffold";
import { formatDisplayDate } from "@Light/utils/dateHelpers";

export type RenewConfirmationProps = {
  transitionDate: Date;
  onDone: () => void;
  isRecent?: boolean;
};

export const RenewConfirmation: React.FC<RenewConfirmationProps> = ({
  transitionDate,
  onDone,
  isRecent,
}) => {
  const scaffold = useScaffold();
  const PageBody = scaffold.page.pageBody;
  const Title = scaffold.page.title;
  const Subtitle = scaffold.page.subtitle;

  const goToDashboardOnExit = scaffold.page.goToDashboardOnExit;

  useMarkFlowCompleted();

  const formattedDate = formatDisplayDate(transitionDate);

  return (
    <PageBody
      footer={
        <ButtonFooter>
          <Button size="lg" className="w-full" onClick={onDone}>
            {goToDashboardOnExit ? "Go to dashboard" : "All set"}
          </Button>
        </ButtonFooter>
      }
    >
      <div className="absolute top-1/2 left-0 w-full -translate-y-1/2 px-4 flex flex-col gap-2">
        <Title>
          {isRecent
            ? "You’ve recently accepted your new energy plan"
            : "You’ve accepted your new energy plan"}
        </Title>
        <Subtitle>
          No additional action is needed from you. <br />
          Your plan will transition after the first meter read after{" "}
          {formattedDate}.
        </Subtitle>
      </div>
    </PageBody>
  );
};
